<m27-dialog #modal class="dialog-planting-report-criteria-component">
    <m27-dialog-header [showClose]="true" [allowMaxSize]="true" (onClose)="isBackButtonEnabled() ? close('Cancel') : closeAll()">
        <div class="title">
            <span>
                <i class="fa fa-table"></i>
                Planting Report Criteria
            </span>
        </div>
    </m27-dialog-header>
    <m27-dialog-body>
        <m27-page-section [caption]="'Crops:'" class="crop-section">
            <div class="horizontal-options">
                <span class="checkbox" *ngFor="let cb of availableCrops">
                    <input type="checkbox" automationid="plantedCropSearch" [id]="'chk' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="cb.IsChecked = $event.target.checked;" />
                    <label [for]="'chk' + cb.Name">{{cb.Name}}</label>
                </span>
            </div>
        </m27-page-section>

        <m27-page-section [caption]="'Years:'" class="year-section">
            <div class="horizontal-options">
                <span class="checkbox" *ngFor="let cb of availableYears">
                    <input type="checkbox" automationid="plantedYearSearch" [id]="'chk' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="cb.IsChecked = $event.target.checked;" />
                    <label [for]="'chk' + cb.Name">{{cb.Name}}</label>
                </span>
            </div>
        </m27-page-section>

        <m27-page-section [caption]="'Permit Statuses:'">
            <div class="horizontal-options">
                <span class="checkbox" *ngFor="let cb of availableStatus">
                    <input type="checkbox" automationid="plantedStatusSearch" [id]="'chk' + cb.Name" [checked]="cb.IsChecked" [disabled]="cb.IsDisabled" (change)="cb.IsChecked = $event.target.checked;" />
                    <label [for]="'chk' + cb.Name">{{cb.Name}}</label>
                </span>
                <button class="small primary" automationid="plantedPermitFind" (click)="searchForPermits()" [disabled]="!validateCanSearchForPermits()">Find Permits</button>
            </div>
        </m27-page-section>

        <m27-page-section [caption]="'Permits:'" [datagrid]="agGrid" [rowSingle]="'Permit'" [rowPlural]="'Permits'" [hideGridBadges]="isSearching || !hasSearched || totalRowCount === 0" style="height: calc(100% - 300px);">
            <ag-grid-angular #agGrid
                             class="ag-theme-fresh"
                             style="height:100%"
                             [gridOptions]="gridOptions">
            </ag-grid-angular>
        </m27-page-section>

        <m27-page-section [caption]="'Plant Date Range:'">
            <m27-input icon="calendar" [config]="dateRangeFromConfig" [(ngModel)]="fromPlantDate" style="width:180px;">
                From Date
            </m27-input>

            <m27-input icon="calendar" [(ngModel)]="minusDays" style="width:140px; margin-left: 10px;" [config]="minusDaysConfig">
                Minus Days
            </m27-input>

            <m27-input icon="calendar" [config]="dateRangeToConfig" [readonly]="!hasValidFromDate" [(ngModel)]="toPlantDate" style="width:170px; margin-left: 10px;"  #dateRangeTo>
                To Date
            </m27-input>
        </m27-page-section>

        <m27-page-section [caption]="'Include in Output:'">
            <div class="horizontal-options">
                <span class="checkbox">
                    <input type="checkbox" automationid="plantedShowPlantDatesNotReported" id="chkPlantDatesNotReported" [(ngModel)]="showPlantDatesNotReported" />
                    <label for="chkPlantDatesNotReported">Plant Dates Not Reported</label>
                </span>
                <span class="checkbox">
                    <input type="checkbox" automationid="plantedShowUpdatedPlantingInfo" id="chkUpdatedPlantingInfo" [(ngModel)]="showUpdatedPlantingInfo" />
                    <label for="chkUpdatedPlantingInfo">Updated Planting Info</label>
                </span>
                <span class="checkbox">
                    <input type="checkbox" automationid="plantedShowLocsWithConstructs" id="chkLocsWithConstructs" [(ngModel)]="showLocsWithConstructs" />
                    <label for="chkLocsWithConstructs">Locations with Constructs</label>
                </span>
            </div>
        </m27-page-section>

    </m27-dialog-body>
    <m27-dialog-footer>
        <div class="dialog-buttons-left">
            <button  automationid="plantedBackOption" *ngFor="let btn of leftButtons; let idx = index" class="button" [autofocus]="btn.IsPrimary()" [disabled]="btn.IsDisabled()" [ngClass]="{'primary' : btn.IsPrimary() }" (click)="btn.Action()">
                {{btn.Text}}
            </button>
        </div>
        <div class="dialog-buttons-right">
            <div automationid="plantedReportIdJustCreated" class="badge warn" *ngIf="showReportJustCreatedBadge">Report {{reportIdJustCreated}} Created</div>
            <button automationid="plantedRunReports" *ngFor="let btn of rightButtons; let idx = index" class="button" [autofocus]="btn.IsPrimary()" [disabled]="btn.IsDisabled()" [ngClass]="{'primary' : btn.IsPrimary() }" (click)="btn.Action()">
                {{btn.Text}}
            </button>
        </div>
    </m27-dialog-footer>
</m27-dialog>
